import { siteClearance } from '@utils/clearanceHelpers'

export default [
  {
    path: '/map',
    name: 'mexico-map',
    component: () => import('@modules/home/views/site-pick/site-pick.vue'),
    meta: {
      authRequired: true,
      authorize: [...siteClearance.admin],
    },
  },
  {
    path: '/acceso-denegado',
    name: 'access-denied',
    component: () => import('@modules/home/views/auth/access-denied.vue'),
    meta: {
      authRequired: false,
    },
  },
  {
    path: '/mx/:store/collaborator-home',
    name: 'collaborator-services-home',
    component: () => import('@modules/home/views/collaborator-home/collaborator-home.vue'),
    meta: {
      authRequired: true,
      authorize: [...siteClearance.collaboratorServices, ...siteClearance.admin],
    },
  },
  {
    path: '/mx/:store/collaborator-vacations',
    name: 'collaborator-services-vacations',
    component: () => import('@modules/home/views/collaborator-vacations/collaborator-vacations.vue'),
    meta: {
      authRequired: true,
      authorize: [
        ...siteClearance.collaboratorServices,
        ...siteClearance.admin,
        ...siteClearance.director,
        ...siteClearance.responsible,
        ...siteClearance.responsibleOperation,
        ...siteClearance.collaborator,
      ],
    },
  },
  {
    path: '/mx/:store/collaborator-vacation-requests',
    name: 'collaborator-services-vacation-requests',
    component: () => import('@modules/home/views/collaborator-vacation-requests/collaborator-vacation-requests.vue'),
    meta: {
      authRequired: true,
      authorize: [
        ...siteClearance.collaboratorServices,
        ...siteClearance.admin,
        ...siteClearance.responsible,
        ...siteClearance.responsibleOperation,
        ...siteClearance.director,
      ],
    },
  },
  {
    path: '/mx/:store/collaborator-extra-journeys',
    name: 'collaborator-services-extra-journeys',
    component: () => import('@modules/home/views/collaborator-extra-journeys/collaborator-extra-journeys.vue'),
    meta: {
      authRequired: true,
      authorize: [...siteClearance.collaboratorServices, ...siteClearance.admin],
    },
  },
  {
    path: '/mx/:store/collaborator-extra-journeys-approval',
    name: 'collaborator-services-extra-journeys-approval',
    component: () => import('@modules/home/views/collaborator-extra-journeys-approval/collaborator-extra-journeys-approval.vue'),
    meta: {
      authRequired: true,
      authorize: [...siteClearance.collaboratorServices, ...siteClearance.admin],
    },
  },
  {
    path: '/mx/reports/identity-report',
    name: 'identity-report-global',
    component: () => import('@modules/reports/views/identity/identity-report.vue'),
    meta: {
      authRequired: true,
      authorize: [...siteClearance.admin],
    },
  },
  {
    path: '/mx/dashboard-leave',
    name: 'dashboard-leave',
    component: () => import('@/modules/reports/views/dashboard-leave/leave-survey-dashboard.vue'),
    meta: {
      authRequired: true,
      authorize: [...siteClearance.admin],
    },
  },
  {
    path: '/mx/terminated-collaborators',
    name: 'terminated-collaborators-global',
    component: () => import('@/modules/collaborators/views/collaborator-terminated/terminated-collaborators-global.vue'),
    meta: {
      authRequired: true,
      authorize: [...siteClearance.admin],
    },
  },
]
